import { PoolMyRewardsDesktop } from './PoolMyRewardsDesktop'

export const PoolMyRewardsMobile = PoolMyRewardsDesktop
